import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";
import LegalShell from "../components/LegalShell";

export default function Refund() {
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <LegalShell title="Refund Policy" subtitle="Last updated: February 2026">
        <p>
          VibeCheck sells digital content — packs, bundles, and subscriptions that
          unlock more questions, dares, and features. This policy explains how
          refunds work.
        </p>

        <h2>The default rule</h2>
        <p>
          Due to the digital nature of our products, refunds are{" "}
          <b>generally not provided</b> after content has been unlocked.
        </p>

        <h2>When we will issue a refund</h2>
        <ul>
          <li>
            <b>Duplicate charge</b>: you were billed twice for the same purchase.
          </li>
          <li>
            <b>Failed delivery</b>: your payment went through but the unlock didn't
            apply within 24 hours and we couldn't fix it.
          </li>
          <li>
            <b>Subscription auto-renew you didn't notice</b>: contact us within 7
            days of the renewal and we'll review case-by-case.
          </li>
          <li>
            <b>Anything required by your local consumer law</b>: we will always
            honour rights granted by applicable law (UK / EU / etc.).
          </li>
        </ul>

        <h2>When we won't issue a refund</h2>
        <ul>
          <li>You changed your mind after unlocking content.</li>
          <li>You finished a pack and feel "done".</li>
          <li>
            You stopped using the app but didn't cancel an active subscription —
            cancel from your Stripe receipt, then we won't charge again.
          </li>
        </ul>

        <h2>How to request a refund</h2>
        <p>
          Email{" "}
          <a href="mailto:playvibcheck@gmail.com">
            playvibcheck@gmail.com
          </a>{" "}
          with your Stripe receipt or transaction id, the email address used, and a
          short note about what happened. We aim to respond within 3 business days.
        </p>

        <h2>Subscriptions</h2>
        <p>
          You can cancel an active subscription at any time. Cancelling stops the
          next renewal — you keep access until the end of the period you've already
          paid for.
        </p>
      </LegalShell>
      <Footer />
      <BottomTabBar />
    </div>
  );
}
